(() => {
  window.swinger = {
    ...window.swinger,
    consent: {
      isAllowed: (key) => {
        const consent = window.swinger.cookie.get('consent');

        return consent && consent.indexOf(key) > -1;
      },
    },
  };
})();
